'use client';

import { useContext } from 'react';
import type { WishlistContextValue } from '../wishlist-provider-optimized';
import { WishlistContext } from '../wishlist-provider-optimized';

/**
 * Safe version of useWishlist that returns null when wishlist is disabled
 * instead of throwing an error. Use this in components that should work
 * with or without wishlist functionality.
 */
export function useWishlistSafe(): WishlistContextValue | null {
  const context = useContext(WishlistContext);

  if (!context?.enabled) {
    return null;
  }

  return context;
}

/**
 * Check if wishlist functionality is available in the current context
 */
export function useIsWishlistAvailable(): boolean {
  const context = useWishlistSafe();
  return Boolean(context?.enabled);
}
